/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { CMD } from "../../commands/CMD";
import { Editor } from "../../Editor";

export function registerAssetMenus(dc: Editor): void {
	const menuSvc = dc.get("menuService");

	menuSvc.registerMenuItem("main.create", {
		id: "addAsset",
		label: "Asset",
		tooltip: "Open dialog to upload new file asset.",
		icon: "mdi/file",
		flags: [ "primary" ],
		order: 120,
		commandId: CMD.ASSET.CREATE.OPEN_ADD
	});
}
